import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  HStack,
  Tag,
  Container,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import PlatformIcon from './PlatformIcon';
import { useLegalLang } from '../LegalLangContext';
import { APP_META } from '../content/appMeta';

const PlatformHero = ({ platform, docTitle }) => {
  const { t, lang } = useLegalLang();

  const dateStr = new Date(APP_META.effectiveDate).toLocaleDateString(
    lang === 'vi' ? 'vi-VN' : 'en-US',
    { year: 'numeric', month: 'long', day: 'numeric' },
  );

  return (
    <Box position="relative" overflow="hidden" pb={10} pt={8}>
      {/* Gradient backdrop riêng cho platform */}
      <Box
        position="absolute"
        inset={0}
        opacity={0.08}
        bgGradient={platform.gradient}
        pointerEvents="none"
      />
      <Box
        position="absolute"
        inset={0}
        bgGradient="linear(to-b, transparent, surface.base)"
        pointerEvents="none"
      />

      <Container maxW="6xl" px={{ base: 4, md: 6 }} position="relative">
        <HStack
          as={RouterLink}
          to="/legal"
          spacing={1.5}
          color="text.muted"
          fontSize="sm"
          _hover={{ color: 'brand.700' }}
          mb={5}
          display="inline-flex"
        >
          <FiArrowLeft size={14} />
          <Text>{t('backToLegal')}</Text>
        </HStack>

        <Flex
          align={{ base: 'flex-start', md: 'center' }}
          direction={{ base: 'column', md: 'row' }}
          gap={5}
        >
          <Flex
            boxSize={{ base: '56px', md: '64px' }}
            borderRadius="16px"
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            boxShadow="0 8px 24px rgba(0,0,0,0.06)"
            align="center"
            justify="center"
            flexShrink={0}
          >
            <PlatformIcon platform={platform} size={32} />
          </Flex>

          <Box flex={1}>
            <HStack spacing={2} mb={2}>
              <Tag
                size="sm"
                bg="white"
                color="text.secondary"
                border="1px solid"
                borderColor="gray.200"
                fontWeight="500"
              >
                {platform.name}
              </Tag>
              <Tag
                size="sm"
                bg="brand.50"
                color="brand.700"
                fontWeight="600"
                border="1px solid"
                borderColor="brand.100"
              >
                {docTitle}
              </Tag>
            </HStack>
            <Heading
              as="h1"
              fontSize={{ base: '2xl', md: '3xl' }}
              fontWeight="700"
              color="text.primary"
              lineHeight="1.2"
            >
              {docTitle} — {platform.name}
            </Heading>
            <Text mt={2} color="text.muted" fontSize="sm">
              {t('effectiveDateLabel')}: <Text as="span" color="text.secondary" fontWeight="500">{dateStr}</Text>
            </Text>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default PlatformHero;
